import { render, staticRenderFns } from "./EditAdministratorComponent.vue?vue&type=template&id=60e1d1d0&"
import script from "./EditAdministratorComponent.vue?vue&type=script&lang=js&"
export * from "./EditAdministratorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports